class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.modal = this.classList.contains('modal');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button.cart-notification__close, button[data-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    if (this.modal && this.header) {
      this.classList.add('open');
      document.body.classList.add('no-scroll');
    }

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true}
    );

    document.body.addEventListener('click', this.onBodyClick);

    const updateGlide = new CustomEvent('updateGlide', {
      detail: [
        {
          id: 'cart-shade-upsell'
        }
      ]
    });
    document.dispatchEvent(updateGlide);
  }

  close() {
    this.notification.classList.remove('active');
    if (this.modal) {
      this.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  /*
    Dev servers don't always return the section in the cart response
    If they're not returned we manually fetch them
    See: https://github.com/Shopify/shopify-cli/issues/1797#issuecomment-1153484659
  */
  async renderContents(parsedState) {
    this.cartItems = parsedState.items;
    this.cartItemKey = parsedState.key ? parsedState.key : parsedState.items[0].key;
    // Fetch missing sections in development environments
    if (!parsedState.sections) {
      const sections = await fetch(
        `${routes.cart_url}?sections=${this.getSectionsToRender().map((section) => section.id)}`
      );
      parsedState.sections = await sections.json();
    }
    this.getSectionsToRender().forEach((section) => {
      if (!section.itemsArray) {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      } else {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector,
          section.itemsArray
        );
      }
    });
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        itemsArray: this.cartItems
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', array = []) {
    const DOMElement = new DOMParser().parseFromString(html, 'text/html');
    const cartNotificationHTML = DOMElement.querySelector(`[id="shopify-section-cart-notification-product"]`);
    const htmlElements = [];

    if (cartNotificationHTML) {
      array.forEach((cartItem) => {
        htmlElements.push(DOMElement.querySelector(`[id="cart-notification-product-${cartItem.key}"]`).innerHTML);
      });
      return htmlElements.join('');
    } else {
      return DOMElement.querySelector(selector).innerHTML;
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
